import { memo } from "react";
import PropTypes from "prop-types";
import Collapse from "app/components/ui/collapse/Collapse";
import MyInformationsContainer from "app/pages/Booking/MyInformations/MyInformationsContainer";
import UsefulInformation from "app/pages/FicheProduit/components/UsefulInformation/UsefulInformation";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import isEmpty from "lodash/isEmpty";
import { Route, Routes } from "react-router-dom";
import ContractRemarks from "app/pages/Booking/ContractRemarks";
import "./BookingInformation.scss";
import { ArrowDownIcon } from "app/icons/navigation";

const BookingInformation = ({
	showProductUsefulInformation,
	dvaf = {},
	usefulInformations = {},
	contractRemarks,
}) => {
	return (
		<>
			{contractRemarks && (
				<Routes>
					<Route
						path="/payment"
						element={<ContractRemarks remarks={contractRemarks} />}
					/>
					<Route
						path="/restoreSession"
						element={<ContractRemarks remarks={contractRemarks} />}
					/>
				</Routes>
			)}

			<Routes>
				{!isEmpty(usefulInformations) && showProductUsefulInformation && (
					<Route
						path="/quote"
						element={
							<Collapse
								expandIcon={({ isActive }) => {
									return (
										<ArrowDownIcon
											style={{
												transition: "transform .2s ease",
												transform: `rotate(${isActive ? 180 : 0}deg)`,
											}}
										/>
									);
								}}
							>
								<Collapse.Panel
									headerClass="booking-useful-information__header"
									header={
										<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
											<FormattedMessage id="useful.information.title" />
										</Typography>
									}
								>
									<div className="booking-useful-information">
										<UsefulInformation
											usefulInformations={usefulInformations}
										/>
									</div>
								</Collapse.Panel>
							</Collapse>
						}
					/>
				)}

				{(!isEmpty(dvaf) || !isEmpty(dvaf.optional)) && (
					<>
						<Route
							path="/payment"
							element={
								<Collapse
									expandIcon={({ isActive }) => {
										return (
											<ArrowDownIcon
												style={{
													transition: "transform .2s ease",
													transform: `rotate(${isActive ? 180 : 0}deg)`,
												}}
											/>
										);
									}}
								>
									<Collapse.Panel
										headerClass="booking-useful-information__header"
										header={
											<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
												<FormattedMessage id="payment.myinformations.fa.title" />
											</Typography>
										}
									>
										<div className="booking-useful-information">
											<MyInformationsContainer />
										</div>
									</Collapse.Panel>
								</Collapse>
							}
						/>
						<Route
							path="/restoreSession"
							element={
								<Collapse
									expandIcon={({ isActive }) => {
										return (
											<ArrowDownIcon
												style={{
													transition: "transform .2s ease",
													transform: `rotate(${isActive ? 180 : 0}deg)`,
												}}
											/>
										);
									}}
								>
									<Collapse.Panel
										headerClass="booking-useful-information__header"
										header={
											<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
												<FormattedMessage id="payment.myinformations.fa.title" />
											</Typography>
										}
									>
										<div className="booking-useful-information">
											{<MyInformationsContainer />}
										</div>
									</Collapse.Panel>
								</Collapse>
							}
						/>
					</>
				)}
			</Routes>
		</>
	);
};

BookingInformation.propTypes = {
	showProductUsefulInformation: PropTypes.bool,
	dvaf: PropTypes.object,
	usefulInformations: PropTypes.object,
	contractRemarks: PropTypes.string,
};

export default memo(BookingInformation);
